import NotificationsIcon from "@material-ui/icons/Notifications";
import { token } from "functions/Helper";
import CompleteAppsNotification from "views/SendAppsNotification/CompleteAppsNotification";
import CreateSendAppsNotification from "views/SendAppsNotification/CreateSendAppsNotification";
import DeleteAppsNotification from "views/SendAppsNotification/DeleteAppsNotification";
import EditAppsNotification from "views/SendAppsNotification/EditAppsNotification";
import InDraftAppsNotification from "views/SendAppsNotification/InDraftAppsNotification";
import InProcessAppsNotification from "views/SendAppsNotification/InProcessAppsNotification";
import SubmitSendAppsNotification from "views/SendAppsNotification/SubmitSendAppsNotification";
import ViewAppsNotification from "views/SendAppsNotification/ViewAppsNotification";

const sendAppsNotification = () => {
  let views = [];

  if (
    token["booking.apps_notifications.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views = views.concat([
      {
        path: "/SendAppsNotification/InDraft",
        name: "In Draft",
        mini: "IN",
        component: InDraftAppsNotification,
        layout: "/admin"
      },
      {
        path: "/SendAppsNotification/InProcess",
        name: "In Process",
        mini: "IP",
        component: InProcessAppsNotification,
        layout: "/admin"
      },
      {
        path: "/SendAppsNotification/Complete",
        name: "Complete",
        mini: "CM",
        component: CompleteAppsNotification,
        layout: "/admin"
      }
    ]);
  }

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Send Apps Notifications",
        icon: NotificationsIcon,
        state: "sendNotificationCollapse",
        views: views
      }
    ];
  return [];
};

const sendAppsNotificationHidden = () => {
  let views = [];

  if (
    token["booking.apps_notifications.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/SendAppsNotification/View",
      name: "View Send Apps Notification",
      component: ViewAppsNotification,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (
    token["booking.apps_notifications.write"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views = views.concat([
      {
        path: "/SendAppsNotification/Create",
        name: "Create Send Apps Notification",
        component: CreateSendAppsNotification,
        layout: "/admin"
      },
      {
        path: "/SendAppsNotification/Edit",
        name: "Edit Send Apps Notification",
        component: EditAppsNotification,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/SendAppsNotification/Delete",
        name: "Delete Send Apps Notification",
        component: DeleteAppsNotification,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/SendAppsNotification/Submit",
        name: "Submit Send Apps Notification",
        component: SubmitSendAppsNotification,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      }
    ]);
  }

  return [
    {
      collapse: true,
      name: "Send Apps Notification Hidden",
      state: "sendAppsNotificationHidden",
      hideInSidebar: true,
      views: views
    }
  ];
};

export { sendAppsNotification, sendAppsNotificationHidden };
